export function isEmpty(value) {
    return value == undefined;
}
export function isBoolean(value) {
    return typeof value === 'boolean';
}
export function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
export function isString(value) {
    return typeof value === 'string';
}
export function isFilledString(value) {
    return typeof value === 'string' && !!value;
}
export function isTruthy(value) {
    return !!value;
}
export function isArray(value) {
    return Array.isArray(value);
}
export function isFilledArray(value) {
    return Array.isArray(value) && !!value.length;
}
export function isUint8Array(value) {
    return Object.prototype.toString.call(value) === '[object Uint8Array]';
}
export function isFunction(value) {
    return typeof value === 'function';
}
export function isObject(value) {
    return value !== null && typeof value === 'object';
}
export function isFilledObject(value) {
    return isObject(value) && !!Object.keys(value).length;
}
export function isNonArrayObject(value) {
    return isObject(value) && !Array.isArray(value);
}
export function isFilledMapObject(value) {
    return isNonArrayObject(value) && !!Object.keys(value).length;
}
export function isError(value) {
    return !!(value && value.stack && value.message);
}
export function isDate(value) {
    return toString.call(value) === '[object Date]';
}
export function isRegExp(value) {
    return toString.call(value) === '[object RegExp]';
}
export function isPromise(value) {
    return (isObject(value) || isFunction(value)) && 'then' in value && isFunction(value.then);
}
export function isElement(value) {
    return isObject(value) && value.nodeType === 1;
}
function getClassChain_(value, chain) {
    if (isFunction(value)) {
        if (!value.name || value === Object) {
            return chain;
        }
        chain.push(value);
        getClassChain_(Object.getPrototypeOf(value), chain);
    }
    else if (isObject(value)) {
        getClassChain_(value.constructor, chain);
    }
    return chain;
}
export function getClassChain(value) {
    return getClassChain_(value, []);
}
export function getClassChainNames(value) {
    return getClassChain_(value, []).map((item) => item.name);
}
export function isInstanceOf(value, type) {
    if (!isObject(value) || !isFunction(type)) {
        return false;
    }
    return getClassChainNames(value).some((item) => item === type.name);
}
//# sourceMappingURL=is.js.map